import Quill from 'quill';

class AttachmentHandler {
  quill: Quill;
  handler: string;
  range: number;
  fileHolder: HTMLInputElement;
  id: number;
  handlerId: string;
  options: {
    upload: () => void;
    icons: {
      trash: string;
      file: string;
      download: string;
      paperClip: string;
    };
  };

  constructor(
    quill: Quill,
    options: {
      upload: () => void;
      icons: {
        trash: string;
        file: string;
        download: string;
        paperClip: string;
      };
    }
  ) {
    // save the quill reference
    this.quill = quill;
    this.handler = "attachment";
    this.range = null;
    this.id = 0;
    this.options = options;
    this.applyForToolbar();
  }

  attachmentIconHTML() {
    return `<img src="${this.options.icons.paperClip}" />`;
  }

  appendAttachmentIcon(toolbar) {
    const toolbarContainer = toolbar.container;
    const _elements = toolbarContainer.getElementsByClassName("ql-attachment");

    const style = document.createElement("style");
    style.appendChild(
      document.createTextNode("svg .file-toolbar:hover{ fill: #0065cc }")
    );

    if (_elements.length > 0) {
      let node = document.createElement("svg");
      node.innerHTML = this.attachmentIconHTML();

      const _element = _elements[0];
      if (!_element) return;

      if (_element?.children.length <= 0) {
        _element.appendChild(style);
        _elements[0].appendChild(node);
      }
    }
  }

  applyForToolbar() {
    const toolbar = this.quill.getModule("toolbar");

    this.appendAttachmentIcon(toolbar);
    if (toolbar)
      toolbar.addHandler(this.handler, this.selectLocalFile.bind(this));
  }

  selectLocalFile() {
    const _accpepted =
      this.handler === "attachment" ? "*" : `${this.handler}/*`;
    this.range = this.quill.getSelection();
    this.fileHolder = document.createElement("input");
    this.fileHolder.setAttribute("type", "file");
    this.fileHolder.setAttribute("accept", _accpepted);
    this.fileHolder.onchange = this.fileChanged.bind(this);
    this.fileHolder.click();
  }

  fileChanged() {
    const file = this.loadFile(this);

    if (!file) {
      console.warn(
        "[File not selected] File is missing, please try to select file again!"
      );
      return;
    }
  }

  generateID() {
    const id = this.id;
    this.id = id + 1;
    return `QUILL_UPLOAD_HANDLER-${id}`;
  }

  loadFile(context: this) {
    const file = context.fileHolder.files[0];
    this.handlerId = this.generateID();

    const fileReader = new FileReader();
    fileReader.addEventListener(
      "load",
      () => {
        this.embedFile(fileReader.result, file);
      },
      false
    );

    if (!file) {
      console.warn("[File not found] Something was wrong, please try again!!");
      return;
    }

    fileReader.readAsDataURL(file);

    return file;
  }

  embedFile(_result: string | ArrayBuffer, file: File) {
    // @ts-ignore
    this.options.upload(file, (url: string) => {
      this.insertBase64Data(url, file.name);
    });
  }

  insertBase64Data(url: string | ArrayBuffer, fileName: string) {
    const range = this.quill.getSelection();
    this.quill.insertEmbed(range.index, this.handler, {
      fileName,
      id: this.handlerId,
      url,
      icons: this.options.icons,
    });
  }
}

export default AttachmentHandler;
